import { useState, useEffect, useMemo } from "react";
import {
  Grid,
  Container,
  Paper,
  Typography,
  Box,
  Snackbar,
  Alert,
  Tabs,
  Tab,
} from "@mui/material";
import { SmartToyOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import LoginForm from "./AuthForms/LoginForm";
import SignupForm from "./AuthForms/SignupForm";
import PasswordResetForm from "./AuthForms/PasswordResetForm";

import LoginPage_banner from "../assets/images/LoginPage_banner.png";
import { emailRegex, strongPasswordRegex, firstNameRegex, lastNameRegex } from "../utils/authUtils";

import { authLoginUser } from "../api/apiService";
import { signUpUser } from "../api/apiService";
import { verifySignUpUserEmail } from "../api/apiService";
import { verifyForgotPasswordEmail } from "../api/apiService";
import { resetPassword } from "../api/apiService";

export default function AuthPage() {
  // snackbar for alert message
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Navigation
  const navigate = useNavigate();

  // Auth UI state
  const [tab, setTab] = useState(0);
  const [passwordReset, setPasswordReset] = useState(false);

  // Loading states
  const [loading, setLoading] = useState(false);

  // Password show/hide
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Login states
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [emailValid, setEmailvalid] = useState({
    login: true,
    signup: true,
    resetPassword: true,
  });
  const [passwordValid, setPasswordValid] = useState({
    login: true,
    signup: true,
    resetPassword: true,
  });
  const [loginFailedError, setLoginFailedError] = useState(null);

  // Signup states
  const [signupData, setSignupData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [signUpFailedError, setSignUpFailedError] = useState(null);
  const [firstNameValid, setFirstNameValid] = useState(true);
  const [lastNameValid, setLastNameValid] = useState(true);
  const [signupDataEntered, setSignupDataEntered] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(true);
  const [verifyCode, setVerifyCode] = useState("");
  const [verifyCodeMismatch, setVerifyCodeMismatch] = useState(false);

  // Password reset states
  const [passwordResetData, setPasswordResetData] = useState({
    email: "",
    resetCode: "",
    password: "",
    confirmPassword: "",
  });
  const [passwordResetStep, setPasswordResetStep] = useState(0);
  const [passwordResetError, setPasswordResetError] = useState(null);

  // Slides for left-side carousel
  const slides = useMemo(() => ([
    {
      eyebrow: "AI Lead Gen",
      title: "Automated lead generation",
      description: "Find high-intent leads with AI-powered enrichment and smart filters.",
      image: LoginPage_banner,
    },
    {
      eyebrow: "Smart Outreach",
      title: "Intelligent email sequencing",
      description: "Personalized cold emails, follow-ups, and timing optimized by AI.",
      image: LoginPage_banner,
    },
    {
      eyebrow: "Insights",
      title: "Real-time analytics & AI insights",
      description: "Track opens, clicks, replies, and pipeline performance at a glance.",
      image: LoginPage_banner,
    },
  ]), []);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(id);
  }, [slides.length]);

  // Redirect logged in user
  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      navigate("/home");
    }
  }, [navigate]);

 /*For Login valid email check */
  useEffect(() => {
  const validateEmailID = () => {
      if (loginData.email.trim() === "") {
        setEmailvalid( prev => ({...prev, login:true})); // Reset to valid while blank
      } else if (!emailRegex.test(loginData.email)) {
        setEmailvalid( prev => ({...prev, login:false})); // Invalid format
      } else {
        setEmailvalid( prev => ({...prev, login:true})); // Valid
      }     
    };
    validateEmailID();
  }, [loginData.email]);

  /*For Login  passowrd check */
   useEffect(() => {
  const validatePassword = () => {
      if (loginData.password.trim() === "") {
        setPasswordValid(prev => ({...prev, login:true})); // Reset to valid while blank
      } else if (!strongPasswordRegex.test(loginData.password)) {
        setPasswordValid(prev => ({...prev, login:false})); // Invalid format
      } else {
        setPasswordValid(prev => ({...prev, login:true})); // Valid
      }
    };
    validatePassword();
  }, [loginData.password]);

  /*For Signup valid First name */
  useEffect(() => {
    if(signupData.firstName.trim() === ""){
      setFirstNameValid(true);
    }else if(!firstNameRegex.test(signupData.firstName)){
      setFirstNameValid(false);
    }else{
      setFirstNameValid(true);
    }
  },[signupData.firstName])

    /*For Signup valid Last name */
  useEffect(() => {
    if(signupData.lastName.trim() === ""){
      setLastNameValid(true);
    }else if(!lastNameRegex.test(signupData.lastName)){
      setLastNameValid(false);
    }else{
      setLastNameValid(true);
    }
  },[signupData.lastName])

  /*For Signup valid email check */
   useEffect(() => {
  const validateEmailID = () => {
      if (signupData.email.trim() === "") {
        setEmailvalid(prev => ({...prev, signup:true})); // Reset to valid while blank
      } else if (!emailRegex.test(signupData.email)) {
        setEmailvalid(prev => ({...prev, signup:false})); // Invalid format
      } else {
        setEmailvalid(prev => ({...prev, signup:true})); // Valid
      }      
    };
    validateEmailID();
  }, [signupData.email]);

  /*For Signup strong passowrd check */
   useEffect(() => {
  const validatePassword = () => {
      if (signupData.password.trim() === "") {
        setPasswordValid(prev => ({...prev, signup:true})); // Reset to valid while blank
      } else if (!strongPasswordRegex.test(signupData.password)) {
        setPasswordValid(prev => ({...prev, signup:false})); // Invalid format
      } else {
        setPasswordValid(prev => ({...prev, signup:true})); // Valid
      }
    };
    validatePassword();
  }, [signupData.password]);

  /*For Signup confirm passowrd match*/
   useEffect(() => {
  const validateConfirmPassword = () => {
      if (signupData.confirmPassword.trim() === "") {
        setConfirmPassword(true); // Reset to valid while blank
      } else if (signupData.password!==signupData.confirmPassword) {
        setConfirmPassword(false); // password mismatch
      } else {
        setConfirmPassword(true); // password match
      }
    };
    validateConfirmPassword();
  }, [signupData.confirmPassword, signupData.password]);


  /*For Reset password - valid email check */
    useEffect(() => {
    const validateEmailID = () => {
        if (passwordResetData.email.trim() === "") {
          setEmailvalid(prev => ({...prev, resetPassword:true})); // Reset to valid while blank
        } else if (!emailRegex.test(passwordResetData.email)) {
          setEmailvalid(prev => ({...prev, resetPassword:false})); // Invalid format
        } else {
          setEmailvalid(prev => ({...prev, resetPassword:true})); // Valid
        }     
      };
      validateEmailID();
    }, [passwordResetData.email]);

  /*For Reset password - passowrd check */
    useEffect(() => {
    const validatePassword = () => {
        if (passwordResetData.password.trim() === "") {
          setPasswordValid(prev => ({...prev, resetPassword:true})); // Reset to valid while blank
        } else if (!strongPasswordRegex.test(passwordResetData.password)) {
          setPasswordValid(prev => ({...prev, resetPassword:false})); // Invalid format
        } else {
          setPasswordValid(prev => ({...prev, resetPassword:true})); // Valid
        }
      };
      validatePassword();
    }, [passwordResetData.password]);


  /*For Signup confirm passowrd match*/
    useEffect(() => {
    const validateConfirmPassword = () => {
        if (passwordResetData.confirmPassword.trim() === "") {
          setConfirmPassword(true); // Reset to valid while blank
        } else if (passwordResetData.password!==passwordResetData.confirmPassword) {
          setConfirmPassword(false); // password mismatch
        } else {
          setConfirmPassword(true); // password match
        }
      };
      validateConfirmPassword();
    }, [passwordResetData.confirmPassword, passwordResetData.password]);

  /* Login button click */
  const handleLogin = () => {
    setLoading(true);
    const payload = {
      email:loginData.email,
      password:loginData.password
    }

    /* Setting Error message empty - Reset to initail state  */
    setLoginFailedError(null);
    setSignUpFailedError(null);
    setPasswordResetError(null);
   
    // Call auth login API here
    const handleAuthUser = async () =>{
      try {
        const response = await authLoginUser(payload); // use authLoginUser API

        if(response){

          if (response.success) {
            const token = response.data.accessToken; //store auth token from login response
            const clientId = response.data.user.id; // store client id from login response
  
            // Save token to localStorage
            localStorage.setItem('token', JSON.stringify(token));
            localStorage.setItem('clientId', JSON.stringify(clientId));
  
            //Login success
            //console.log('Login success:', response);
            setLoading(false);
            navigate('/home');
          } else {
            setLoginFailedError(response.message || "Login failed.");
            setLoading(false);
          }

        }else{
          setLoginFailedError( "Server not responding, please try again later");
        }

      } catch (error) {
          //console.log('Login failed:', error);
          setLoading(false);
          //user 
          console.log(error);
          try {
            let errorMessage = "Some issue with connecting to server";

            if (error?.status === 401) {
              if (process.env.NODE_ENV !== 'production') {
                console.log("user unauthorized");
              }
              errorMessage = "Invalid username or password"
            }

            if (error && error.message) {
              //Axios/JS error ("Network Error", "timeout", etc.)
              if (typeof error.message === "string") {
                // If error.message itself is just a string, for network error and unauthorized
                errorMessage = error.message;
              } else if (error && error.message && error.message.message) {
                //Unauthorized
                errorMessage = error.message.message;
              } else {
                errorMessage = "Unkown error"
              }
            }

            setLoginFailedError(errorMessage);
          } catch (e) {
            //console.error("Error while handling login error:", e);
            setLoginFailedError("Some issue with contacting server");
          }
      }
    }

    handleAuthUser();

  };
  /* Reset Password click in login page*/
  const handlePasswordReset = () => {
    setPasswordReset(true); //open password reset form 
    setPasswordResetStep(0); // step 0 - Email verify

    // no error message at initial
    setPasswordResetError(null) 
    setSignUpFailedError(null);
    setLoginFailedError(null);

  }

  /* Reset Password Verify Email click */
  const handlePasswordResetCode = () => {
    setLoading(true);
    const payload = {
      email:passwordResetData.email,
    }

    // Call forgot password API for Email verify
    const handleForgotPassowrd = async () =>{
      try {
          // no error message at initial
          setPasswordResetError(null) 
          setSignUpFailedError(null);
          setLoginFailedError(null);
          //const response = 
          await verifyForgotPasswordEmail(payload); 
          setLoading(false);
          //Code sent success
          //console.log('Verify Email code sent successfully:', response);
          //alert(response.data.message);
          //go to next step for new password entry
          setPasswordResetStep(1);

      } catch (error) {
         //verify failed
          setLoading(false);
          console.error('Verify Email failed:', error);
          setPasswordResetStep(0); // stay in step 0 - Email verify page
          try{
            if(error.message.message==="Network Error"){
              setPasswordResetError("Network Issue");
            }else{
              setPasswordResetError(error.message.message);
            }
          }catch{
              setPasswordResetError("Some issue with contacting server");
          }
      }
    }

    handleForgotPassowrd();

  }

  /* Reset Password Submit */
  const handlePasswordResetSubmit = () => {
    setLoading(true);
    const payload = {
      email: passwordResetData.email,
      confirmationCode: passwordResetData.resetCode,
      newPassword: passwordResetData.password
    }
     
    // Call reset password API submit
    const handleForgotPassowrd = async () =>{
      try {
          await resetPassword(payload); 
          setLoading(false);
          //reset success
           setSnackbar({ open: true, message: 'Password Reset successfully', severity: 'success' });
          //go to Login page
          setPasswordReset(false);

      } catch (error) {
         //verify failed
         setLoading(false);
         try{
           if(error.message.message==="Network Error"){
             setPasswordResetError("Network Issue");
           }else{
             setPasswordResetError(error.message.message);
           }
         }catch{
          setPasswordResetError("Some issue conatcting server");
         }
      }
    }

    handleForgotPassowrd();

  }

  /* Sign up button click */
  const handleSignup = () => {
    setLoading(true);
    // no error message at initial
    setPasswordResetError(null) 
    setSignUpFailedError(null);
    setLoginFailedError(null);

    const payload = {
      firstName:signupData.firstName,
      lastName:signupData.lastName,
      email:signupData.email,
      password:signupData.password
    }

    // Call signup API here
    const handleAddUser = async () =>{
      try {
          const response = await signUpUser(payload); // use your Signup API for adding user
          //Signup success
          if(response.success){
            setLoading(false);
            //need to enter verify code for verifing email   
            setSignupDataEntered(true);
          } else {
            setLoading(false);
            setSignUpFailedError("Signup failed.");
          }
          // setLoading(false);
          // if (response.status === 202) {
          //   //need to enter verify code for verifing email   
          //   setSignupDataEntered(true);
          // }
          //409 - user already exist
          //500 - internal server error
          //202 - sinup

      } catch (error) {
          setLoading(false);
          console.error('Signup failed:', error);
          setSignupDataEntered(false);
          //user unauthorised
          try{
            if(error.message==="Network Error"){
                 setSignUpFailedError("Network Issue");
            } else if(error.status === 409){
              setSignUpFailedError("User with this email already exists");
            }
            // else if(error.response.data.message.message==="User with this email already exists"){
            //   setSignUpFailedError("User with this email already exists");                                              
            // }
            // else if(error.response.data.message.message==="Please check your email to confirm your account"){
            //   //need to enter verify code for verifing email
            //    setSignupDataEntered(true);
               
            // }
            else{
              //unhandled error
              setSignUpFailedError(error.message);
              setSignupData({ firstName: "", lastName: "", email: "", password: "", confirmPassword: "" });
            }          
          }catch{
            setSignUpFailedError("Some issue with contacting server");
          }
      }
    }

    handleAddUser();

  };
  /* verify button click - after Sign up */
  const handleVerifyClick = () =>{
     setLoading(true);
    //alert("Verification code:" + verifyCode);
    // if(verifyCode==='123'){
      
      //API call
      const payload = {
        email:signupData.email,
        token:verifyCode
      }
      const handleVerifyUserEmail = async () =>{
      try {
          await verifySignUpUserEmail(payload); // use your Signup API for adding user

          //email verify success
          setLoading(false);
          setSignupDataEntered(false);
          setVerifyCodeMismatch(false);
          setTab(0);
          //Verification Successful, Login with your credentials
          setSnackbar({ open: true, message: 'Verification Successful, Login with your credentials', severity: 'success' });
          setVerifyCode("");
      } catch (error) {
          setLoading(false);
          console.error('Signup failed:', error);
          setVerifyCodeMismatch(true);
          //Verification code mismatch
          setSnackbar({ open: true, message: 'Verification code mismatch', severity: 'error' });
      }
      }

      handleVerifyUserEmail();
  }
  /* Google button click */
  const handleGoogleLogin = () => {
    //Google login clicked
    setSnackbar({ open: true, message: 'Google login/signup coming soon..', severity: 'warning' });
    // Google login API here
  };

  return (
    <>
      <Grid container sx={{ minHeight: "100vh" }}>
        {/* Snackbar */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
        {/* Left side branding */}
        <Grid
          size={{ xs: 12, md: 7 }}
          sx={{
            backgroundImage: (theme) => theme.palette.gradient.primary,
            color: "white",
            display: { xs: "block", md: "flex"},
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            p: { xs: 3, md: 4 },
            position: 'relative',
            overflow: 'hidden',
            height: {xs: 80, md: 'inherit'}
          }}
        >
          <Box sx={{ width: '100%', maxWidth: 560 }}>
            <Box sx={{ display: "flex", alignItems:"center", gap: 1, mb: 2 }}>
              <SmartToyOutlined fontSize="large" />
              <Typography variant="h5" sx={{ fontWeight: 800, letterSpacing: 0.2 }}>
                ThomoBot
              </Typography>
            </Box>

            {/* Carousel */}
            <Box sx={{ position: 'relative', height: { xs: 280, md: 360 }, display: {xs: "none", md: "block"} }}>
              {slides.map((s, idx) => (
                <Box
                  key={idx}
                  sx={{
                    position: 'absolute',
                    inset: 0,
                    display: idx === currentSlide ? 'block' : 'none',
                  }}
                >
                  <Box
                    component="img"
                    src={s.image}
                    alt={s.title}
                    sx={{ width: '100%', height: { xs: 160, md: 260 }, objectFit: 'cover', borderRadius: 2, mb: 2, boxShadow: 2 }}
                  />
                  <Typography variant="overline" sx={{ opacity: 0.9 }}>
                    {s.eyebrow}
                  </Typography>
                  <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                    {s.title}
                  </Typography>
                  <Typography variant="body1" sx={{ opacity: 0.95 }}>
                    {s.description}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Dots */}
            <Box sx={{ display: {xs:"none", md: 'flex' } , gap: 1, mt: 2 }}>
              {slides.map((_, idx) => (
                <Box
                  key={idx}
                  onClick={() => setCurrentSlide(idx)}
                  sx={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    bgcolor: idx === currentSlide ? 'common.white' : 'rgba(255,255,255,0.5)',
                    cursor: 'pointer',
                    transition: 'all 150ms ease',
                  }}
                />
              ))}
            </Box>
          </Box>
        </Grid>
        {/* Right side form */}
        <Grid
          size={{xs:12, md:5}}
            container
            justifyContent="center"
            alignItems="center"
            sx={{
              minHeight: { md: '100vh' }, // only full height on desktop
              py: { xs: 2, md: 3 },    // remove vertical padding on mobile
              boxSizing: 'border-box', // ensures no overflow from padding
            }}
        >
          <Container maxWidth="sm">
              <Paper elevation={0} sx={{  p: { xs: 2, md: 3 }, borderRadius: 3, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
                {!passwordReset ? (
                  <>
                    <Tabs
                      value={tab}
                      onChange={(e, v) => setTab(v)}
                      centered
                      indicatorColor="primary"
                      textColor="primary"
                    >
                      <Tab
                        label="Log In"
                        sx={{ width: "50%", textTransform: "none", fontSize: "medium" }}
                      />
                      <Tab
                        label="Sign Up"
                        sx={{ width: "50%", textTransform: "none", fontSize: "medium" }}
                      />
                    </Tabs>
                    {tab === 0 && (
                      <LoginForm
                        loginData={loginData}
                        setLoginData={setLoginData}
                        emailValid={emailValid}
                        setEmailvalid={setEmailvalid}
                        passwordValid={passwordValid}
                        setPasswordValid={setPasswordValid}
                        showPassword={showPassword}
                        setShowPassword={setShowPassword}
                        handleLogin={handleLogin}
                        loginFailedError={loginFailedError}
                        loading={loading}
                        handlePasswordReset={() => setPasswordReset(true)}
                        handleGoogleLogin={handleGoogleLogin}
                      />
                    )}
                    {tab === 1 && (
                      <SignupForm
                        signupData={signupData}
                        setSignupData={setSignupData}
                        emailValid={emailValid}
                        setEmailvalid={setEmailvalid}
                        passwordValid={passwordValid}
                        setPasswordValid={setPasswordValid}
                        firstNameValid={firstNameValid}
                        setFirstNameValid={setFirstNameValid}
                        lastNameValid={lastNameValid}
                        setLastNameValid={setLastNameValid}
                        confirmPassword={confirmPassword}
                        setConfirmPassword={setConfirmPassword}
                        showPassword={showPassword}
                        setShowPassword={setShowPassword}
                        showConfirmPassword={showConfirmPassword}
                        setShowConfirmPassword={setShowConfirmPassword}
                        handleSignup={handleSignup}
                        signUpFailedError={signUpFailedError}
                        loading={loading}
                        signupDataEntered={signupDataEntered}
                        verifyCode={verifyCode}
                        setVerifyCode={setVerifyCode}
                        verifyCodeMismatch={verifyCodeMismatch}
                        handleVerifyClick={handleVerifyClick}
                        handleGoogleLogin={handleGoogleLogin}
                      />
                    )}
                  </>
                ) : (
                  <PasswordResetForm
                    passwordResetData={passwordResetData}
                    setPasswordResetData={setPasswordResetData}
                    passwordResetStep={passwordResetStep}
                    setPasswordResetStep={setPasswordResetStep}
                    emailValid={emailValid}
                    setEmailvalid={setEmailvalid}
                    passwordValid={passwordValid}
                    setPasswordValid={setPasswordValid}
                    confirmPassword={confirmPassword}
                    setConfirmPassword={setConfirmPassword}
                    showPassword={showPassword}
                    setShowPassword={setShowPassword}
                    showConfirmPassword={showConfirmPassword}
                    setShowConfirmPassword={setShowConfirmPassword}
                    loading={loading}
                    passwordResetError={passwordResetError}
                    handlePasswordResetCode={handlePasswordResetCode}
                    handlePasswordResetSubmit={handlePasswordResetSubmit}
                    setPasswordReset={setPasswordReset}
                    handlePasswordReset={handlePasswordReset}
                  />
                )}
              </Paper>
            </Container>
          </Grid>
      </Grid>
    </>
  );
}
